import React, { useState, useEffect } from 'react';
import axios from '../../../library/axios';
import { MySwal } from '../../../library/swal';
import { Button } from 'react-bootstrap';
import makeAnimated from 'react-select/animated'
import Select from 'react-select'
import { getSlug, } from "../../../../src/config/routes/guards/slug";

const UploadDokumen = (props) => {
    console.log(props);
    const [loading, setLoading] = useState(false);
    const [disabled, setDisabled] = useState(false);
    const [file, setFile] = useState('');
    const [standar, setStandar] = useState([]);
    const [idStandar, setIdStandar] = useState('');
    const [isDropdownVisible, setIsDropdownVisible] = useState(false);
    const [chapters, setChapters] = useState([]);
    const [selectedOptions, setSelectedOptions] = useState([]);


    const [namaDokumen, setnamaDokumen] = useState('');
    const [base64String, setBase64String] = useState('');
    const [originalName, setOriginalName] = useState('');
    const [originalType, setOriginalType] = useState('');
    const [deskripsi, setDeskripsi] = useState('');

    const animatedComponents = makeAnimated();

    const fileToBase64 = (file) => {
        if (file.type !== 'application/pdf') {
            MySwal.fire({
                icon: 'error',
                title: 'Oops, Error!',
                text: `File Dokumen hanya boleh PDF!`,
            });
            setDisabled(true);
            return false;
        }
        setOriginalType(file.type)
        setOriginalName(file.name);
        if (file) {
            const reader = new FileReader();
            reader.onloadend = () => {
                const base64 = reader.result
                setBase64String(base64)
            };
            reader.readAsDataURL(file);
        }
    }

    const handleUpload = async () => {
        setDisabled(false);

        try {
            setLoading(true);
            setDisabled(true);
            if (base64String === '') {
                MySwal.fire({
                    icon: 'error',
                    title: 'Oops, Error',
                    text: 'Belum ada file terupload!',
                });
                return false;
            }
            const dokumenObj = {
                dokumen: base64String,
                namaFile: originalName,
                mimeType: originalType,
                Deskripsi: deskripsi
            }

            let idDokumen;
            axios({
                url: '/skor/upload-master-dokumen',
                method: 'POST',
                data: dokumenObj,
                headers: { Authorization: `Bearer ${localStorage.getItem(`token${getSlug() ? '-' + getSlug() : ''}`)}` },
            }).then(res => {
                idDokumen = res?.data?.id
                const DataObj = []
                for (var i = 0; i < selectedOptions.length; i++) {
                    var object = {
                        idVariablesAccreditation: selectedOptions[i].value,
                    };
                    DataObj.push(object)
                }
                const convertedObject = { idVariablesAccreditation: props.id };
                DataObj.push(convertedObject)
                let bodyParameters = {
                    idMasterDocument: idDokumen,
                    variablesAccreditation: DataObj
                }
                console.log(bodyParameters);
                axios({
                    url: '/skor/mapping-master-dokumen-to-ep',
                    method: 'POST',
                    data: bodyParameters,
                    headers: { Authorization: `Bearer ${localStorage.getItem(`token${getSlug() ? '-' + getSlug() : ''}`)}` },
                }).then(res => {
                    console.log(res);
                    MySwal.fire({
                        icon: 'success',
                        title: 'Success',
                        text: 'Data tersimpan!'
                    });
                    props.handleCloseUpload()
                }).catch(err => {
                    console.log(err)
                });
            }).catch(err => {
                console.log(err)
            });
        } catch (err) {
            console.log(err?.response?.data?.message);
            MySwal.fire({
                icon: 'error',
                title: 'Oops, Error!',
                text: `Pastikan menggunakan file import yg sesuai.`,
            });
        }
    };

    const handleChangeStandar = async (value) => {
        setIdStandar(value)
        try {
            const options = {
                url: `/chapters/getListByFkAllRelation/${localStorage.getItem('idStandar')}`,
                method: 'GET',
                headers: {
                    'Access-Control-Allow-Origin': '*',
                    Authorization: `Bearer ${localStorage.getItem(`token${getSlug() ? '-' + getSlug() : ''}`)}`,
                },
            };
            const { data } = await axios(options);
            // console.log(data)
            setIsDropdownVisible(true)
            setChapters(data);
        } catch (err) {
            console.log(err.message);
        }
    }

    const dataEp = chapters.flatMap((chapter) => {
        return chapter.elements_accreditations.flatMap((element) => {
            return element.variables_accreditations.map((variable) => {
                return {
                    label: [element.Nomor, variable.Abjad],
                    value: variable.id
                };
            });
        });
    });

    // console.log(dataEp)

    const handleChange = (dataEp) => {
        setSelectedOptions(dataEp);
    };

    // const handleChangeFile = (e) => {
    //     setFile(e.target.files[0]);
    // }

    useEffect(() => {
        handleChangeStandar();
    }, []);


    return (
        <div>
            <div className="mb-3 row">
                <>
                    <label htmlFor="filePath" className="col-sm-4 col-form-label" required>
                        Dokumen Pendukung
                    </label>
                    <div className="col-12">
                        <input
                            type="file"
                            className="form-control"
                            id="filePath"
                            onChange={(e) => fileToBase64(e.target.files[0])}
                        />
                    </div>
                    <label className="col-sm-4 col-form-label" required>
                        Deskripsi Dokumen
                    </label>
                    <div className="col-12">
                        <textarea class="form-control" id="exampleFormControlTextarea1" onChange={(e) => setDeskripsi(e.target.value)} rows="3"></textarea>
                    </div>
                    <label htmlFor="filePath" className="col-sm-4 col-form-label" required>
                        Referensi EP Lain
                    </label>
                    <div className="col-12">
                        <Select
                            closeMenuOnSelect={false}
                            components={animatedComponents}
                            isMulti
                            onChange={handleChange}
                            value={selectedOptions}
                            options={dataEp}
                        />
                    </div>
                </>
            </div>
            <div className="mt-5 row">
                <div className="col-12">
                    <Button variant="danger" size="sm" onClick={() => props.close()}>
                        Tutup
                    </Button>
                    &nbsp;
                    <Button
                        disabled={disabled}
                        variant="success"
                        size="sm"
                        onClick={() => {
                            handleUpload()
                        }}
                    >
                        {loading === true ? 'Mohon Tunggu..' : 'Simpan'}
                    </Button>
                </div>
            </div>
        </div>
    );
};

export default UploadDokumen;
